import { atom } from 'recoil';
export const surveyResultState = atom({
    key: 'surveyResultState',
    default: {
        isLoading: false,
        error: '',
        surveyResult: null,
        reload: false
    }
});
export const onSurveyAnswerState = atom({
    key: 'onSurveyAnswerState',
    default: {
        onAnswer: null
    }
});
